import React from "react";
import "./Header.css";
import { Link } from "react-router-dom";
import { useStateValue } from "./StateProvider";
import { auth } from "./firebase";
import logo from './logo.png';
import { Input, Badge } from 'antd';
import { ShoppingCartOutlined } from '@ant-design/icons';

const { Search } = Input;

const saveBasketToLocal = (userId, basket) => {
  localStorage.setItem(`basket_${userId}`, JSON.stringify(basket));
};

function Header() {
  const [{ basket, user }] = useStateValue();

  const handleAuthenticaton = () => {
    if (user) {
      saveBasketToLocal(user.uid, basket);
      auth.signOut();
    }
  }

  return (
    <div className="header">
      <Link to="/" className="header__logoLink">
        <img
          className="header__logo"
          src={logo} alt="Logo"
        />
      </Link>

      <div className="header__search">
        <Search
          placeholder="Search products..."
          allowClear
          enterButton
          aria-label="Search across the store"
        />
      </div>

      <div className="header__nav">
        <Link to={!user ? '/login' : '#'}>
          <div onClick={handleAuthenticaton} className="header__option">
            <span className="header__optionLineOne">Hello {!user ? 'Guest' : user.email}</span>
            <span className="header__optionLineTwo">{user ? 'Sign Out' : 'Sign In'}</span>
          </div>
        </Link>

        <Link to='/orders'>
          <div className="header__option">
            <span className="header__optionLineOne">Returns</span>
            <span className="header__optionLineTwo">& Orders</span>
          </div>
        </Link>

        <Link to="/checkout" aria-label="View basket">
          <div className="header__optionBasket">
            <Badge count={basket?.length} showZero>
              <ShoppingCartOutlined style={{ fontSize: '22px', color: '#333' }} />
            </Badge>
          </div>
        </Link>
      </div>
    </div>
  );
}

export default Header;
